<template>
  <div :class="['preview-main', isCollapse ? 'preview-main-collapse' : '']">
    <drawer v-model="isCollapse" :isTitle="false" :isShowMask="false" :isUseParentWidth="true" :isShadow="false"
      placement="right" :isAppendBody="false">
      <div class="preview-content" v-loading="iframeLoaded">
        <div class="preview-content-header" :style="isPerviewFile ? '' : 'padding:0;'">
          <template v-if="isPerviewFile">
            <div style="color: #4550DC;">{{ title }}</div>
          </template>
          <template v-else>
            <el-tabs class="preview-content-tabs" v-model="activeName" type="card" @tab-change="handleTabsClick">
              <el-tab-pane v-for="(item) in appList" :key="item.appId" :label="item.appName" :name="item.appId" />
            </el-tabs>
          </template>
          <div>
            <el-button link @click="zoom(false)" v-if="isFull"><i class="iconfont icon-suoxiao1" />缩小</el-button>
            <el-button link @click="zoom(true)" v-else><i class="iconfont icon-fangda2" />最大化</el-button>
            <el-button v-if="isPerviewFile" link @click="downFile"><i class="iconfont icon-xiazai" />下载</el-button>
            <el-button link @click="close" class="close-btn"><i class="iconfont icon-guanbi" /></el-button>
          </div>
        </div>
        <template v-if="isPerviewFile">
          <iframe :src="iframeSrc" frameBorder="0" @load="iframeLoaded = false"
            style="background-color: transparent;"></iframe>
        </template>
        <template v-else-if="openType === 'dataGenerate'">
          <template v-for="(item) in appList" :key="item.id">
            <transactionManagement
              v-if="(item.iId === 1 || item.iId === 5)"
              v-show="item.appId === activeName"
              ref="transactionCenter"
              :dataGenerate="true"
              @open-appDialog="openAppDialog"
              @upInput="upInput"
              :parentQuery="item.query"
              :approvalId="item.approvalId"
              :fileProperty="item.fileProperty"
            />
            <transactionManagements
              v-if="item.iId === 7"
              v-show="item.appId === activeName"
              ref="transactionCenter"
              :dataGenerate="true"
              :parentQuery="item.query"
              :appid="item.approvalId"
              :fileProperty="item.fileProperty"
              @open-appDialog="openAppDialog"
              @upInput="upInput"
            />
          </template>
        </template>
      </div>
    </drawer>
    <app-dialog :dialogInfo="dialogInfo" />
    <el-dialog
      v-model="isInput"
      :destroy-on-close="true"
      :show-close="false"
      :modal="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :class="pdheight== 'auto' ? 'application-routing-dialog-all dialog-height-auto' : 'application-routing-dialog-all'"
      :fullscreen="routingFlowshow"
      :top="isSubmit ? '-100vh' : routingFlowshow ? '0' : pdheight === 'auto' ? 'calc(50vh - ' + (dialogHeight / 2) + 'px)' : '8.9vh'"
      :width="routingFlowshow ? '100%' : (pdwidth + '%')"
      :style="showLink ? 'display:none' : ''"
    >
      <div :class="['dialog-top', isfaceAr !== 0 ? 'dialog-top-black' : '']">
        <div class="apply-name">{{ '' }}</div>
        <div class="apply-right">
          <div class="face-ar" v-if="isfaceAr !== 0">
            <span
              class="active-hover"
              @click="faceArChange"
            >
              <i
                v-show="isfaceAr === 1"
                class="iconfont icon-AR1"
                style="font-size: 20px"
              />
              <i
                v-show="isfaceAr === 2"
                class="iconfont icon-AR"
                style="font-size: 20px"
              />
            </span>
          </div>
          <div v-if="isAi && aiStatus" class="active-hover" @click="upIsAi(isAi === 1 ? 2 : 1)"
           :style="{color: isAi === 1 ? '#4e86ff' : ''}">
            <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/ai.png" style="width:25px;height:25px;vertical-align: inherit;margin-right:4px;" />
            AI小易
          </div>
          <div v-if="flowshow != 2 && !modify">
            <span class="active-hover" @click="onFlowshow">
              <el-icon style="float:left;margin:15px 3px 0 0;"><View /></el-icon>
              {{ getFlowShowText() }}
            </span>
          </div>
          <div>
            <span
              class="active-hover"
              style="margin-right: 5px"
              @click="routingFlowshow = !routingFlowshow"
            >
              <i
                v-show="!routingFlowshow"
                class="iconfont icon-fangda2"
                style="font-size: 14px"
              />
              <i
                v-show="routingFlowshow"
                class="iconfont icon-suoxiao1"
                style="font-size: 14px"
              />
            </span>
            <span class="active-hover" @click="isInput = false">
              <i class="icon iconfont icon-shanchu3" />
              <!--                关闭-->
            </span>
          </div>
        </div>
      </div>
      <!-- 这边需要添加一个传进来的参数下去给发起作为默认值之后的覆盖值使用 -->
      <oaExamineInput
        :approvalId="currentApp.approvalId"
        :modify="modify"
        :person="0"
        v-model:isAi="isAi"
        v-model:pdwidth="pdwidth"
        type="1"
        ref="AuditOpenInput"
        @hideLink="hideLink"
        @refFlowshow="refFlowshow"
        @retRefresh="retRefresh"
        @inputClose="inputClose"
        @getfaceAr="getfaceAr"
        @upIsAi="upIsAi"
        @upIsPcwidth="upIsPcwidth"
        @upIsPcHeight="upIsPcHeight"
        @loadSuccess="loadSuccess"
        @beginSubmit="isSubmit = false"
        v-if="isInput"
      />
    </el-dialog>
  </div>
</template>

<script setup>

import { ref, defineExpose, defineEmits, useTemplateRef, watch, computed, nextTick } from 'vue'
import drawer from '@/components/common/drawer'
import { filePreview } from '@/api/global.js';
import { ElMessage } from 'element-plus'
import transactionManagement from '@/components/clientSide/workbench/transactionManagement.vue'
import transactionManagements from '@/components/clientSide/workbench/transactionManagements.vue'
import appDialog from '@/components/schoolInstrument/mixins/AppDialog.vue'
import oaExamineInput from '@/components/clientSide/oaExamineInput.vue'

const emit = defineEmits(['close', 'zoom'])


// // 测试
// onMounted(() => {
//   openType.value = 'dataGenerate'
//   activeName.value = appList.value[0].appId
//   handleTabsClick(activeName.value)
// })

const transactionCenter = useTemplateRef('transactionCenter')
const AuditOpenInput = useTemplateRef('AuditOpenInput')

const isCollapse = ref(false)
const openType = ref('')
const iframeSrc = ref('')
const fileUrl = ref('')
const iframeLoaded = ref(false)
const title = ref('')
const activeName = ref('1')
const appList = ref([])
const dialogInfo = ref({})

// 新增编辑相关
const showModal = ref(false)
const modify = ref(null)
const isInput = ref(false)
const pdheight = ref('refFlowshow')
const pdwidth = ref(75)
const routingFlowshow = ref(false)
const showLink = ref(false)
const isfaceAr = ref(0)  //0 未配置人脸识别 1 拍摄模式 2 AR模式
const isAi = ref(0)
const aiStatus = ref(false)
const flowshow = ref(2)
const isSubmit = ref(false)
const dialogHeight = ref(0)
const isPerviewFile = computed(() => {
  return ['fileGenerate', 'contentGenerate'].includes(openType.value)
})
const faceArChange = () => {
  isfaceAr.value = isfaceAr.value === 1 ? 2 : 1
  AuditOpenInput.value.faceArChange(isfaceAr.value)
}

const onFlowshow = () => {
  flowshow.value = flowshow.value ? 0 : 1
  AuditOpenInput.value.flowshow = flowshow.value
}

const upIsAi = (val) => {
  isAi.value = val
}

const hideLink = () => {
  showLink.value = true
}

const refFlowshow = (res) => {
  flowshow.value = res
}

const retRefresh = () => {
  const idx = currentIdx.value
  const current = appList.value[idx]
  const ref = transactionCenter.value[idx]
  console.log(ref,'refrefrefref')
  if (current.iId === 1 || current.iId === 5) { 
    // 关于我的
    ref.approvingId = current.approvalId
    const active = current.iId === 1 ? 1 : 5
    ref.resetRefresh(active)
  } else {
    // 全部数据
    ref.resetRefresh(2)
  }
}

const inputClose = () => {
  AuditOpenInput.value.closeSetTime()
  isInput.value = false;
  isSubmit.value = false      
}

const getfaceAr = (val) => {
  isfaceAr.value = val
  if(isfaceAr.value !== 0){
    routingFlowshow.value = true
  } else{
    routingFlowshow.value = false
  }
}

const upIsPcwidth = (val) => {
  pdwidth.value = val
}

const upIsPcHeight = (val) => {
  pdheight.value = val
  if (pdheight.value === 'auto') {
    nextTick(() => {
      setTimeout(() => {
        const dialogElement = document.querySelector('.application-routing-dialog-all');
        if (dialogElement) {
          dialogHeight.value = dialogElement.offsetHeight;
        }
      }, 500);
    });
  }
}

const loadSuccess = () => {
  setTimeout(() => {
    showModal.value = false
  }, 300);
}


const open = (config) => {
  openType.value = config.openType
  // 文件推送相关代码
  console.log(config,'asdadasdadasdas')
  if (openType.value === 'fileGenerate' || openType.value === 'contentGenerate') {
    fileUrl.value = config.fileUrl
    title.value = config.title
    const url = openType.value === 'fileGenerate' ? '/userfiles/' + config.fileUrl : config.fileUrl
    // 获取文件预览地址
    const isEdit = openType.value === 'fileGenerate' ? false : true
    const newUrl = filePreview( { url }, false, isEdit, true)
    // 如果与之前的文件地址不同才重新加载
    if (newUrl) {
      if (iframeSrc.value !== newUrl) {
        iframeLoaded.value = true
        iframeSrc.value = newUrl
      }
    } else {
      ElMessage.warning('该文件不支持预览')
    }
  } else if (openType.value === 'dataGenerate') {
    const portInfo = config.config.portInfo || []
    console.log(portInfo,'[0][0][0]')
    if (portInfo.length !== 0) {
      appList.value = portInfo
      activeName.value = portInfo[0].appId
      handleTabsClick(portInfo[0].appId)
    }
  }
  isCollapse.value = true
}
// 文件下载
const downFile = () => {
  const url = openType.value === 'fileGenerate' ? '/userfiles/' + fileUrl.value : fileUrl.value
  filePreview({ url }, true)
}

// 缩放
const isFull = ref(false)
const zoom = (isfull) => {
  isFull.value = isfull
  emit('zoom', isfull)
}

// 关闭弹窗
const close = () => {
  isCollapse.value = false
  resetData()
  emit('zoom', false)
  emit('close')
}

// 重置数据
const resetData = () => {
  fileUrl.value = ''
  iframeSrc.value = ''
  title.value = ''
  isFull.value = false
}

const openAppDialog = (val) => {
  dialogInfo.value = val
}


const upInput = (e) => {
  if(showModal.value) return false
  showModal.value = true
  modify.value = e
  isInput.value = true;
}


const handleTabsClick = (val) => {
  nextTick(() => {
    const idx = appList.value.findIndex(item => item.appId === val)
    console.log(!transactionCenter.value,'sadadasdasd')
    if (idx === -1) return
    if (!transactionCenter.value) return
    const current = appList.value[idx]
    if (current.show) {
      return
    }
    const ref = transactionCenter.value[idx]
    current.show = true
    if (current.iId === 1 || current.iId === 5) { 
      // 关于我的
      ref.approvingId = current.approvalId
      const active = current.iId === 1 ? 1 : 5
      ref.inquire(active)
    } else {
      // 全部数据
      ref.whetherShow(2)
    }
  })
}

const removeMask = ()=> {
  // 获取遮罩层元素
  const mask = document.getElementById('j-mask-dialogA');
  if (mask) {
    // 使用 setTimeout 模拟遮罩层渐变效果
    mask.style.opacity = 0;
    setTimeout(() => {
      document.body.removeChild(mask);
    }, 300); // 300ms 后删除遮罩层
  }
}

const addMask = () => {
  // 检查遮罩层元素是否已经存在
  const existingMask = document.getElementById('j-mask-dialogA');
  if (existingMask) {
    // 如果遮罩层已经存在，跳过创建步骤
    return;
  }
  // 创建遮罩层元素
  const mask = document.createElement('div');
  mask.id = 'j-mask-dialogA';
  mask.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    transition: opacity 0.3s;
    opacity: 0;
  `;
  // 使用 setTimeout 模拟遮罩层渐变效果
  setTimeout(() => {
    mask.style.opacity = 1;
  }, 10);
  
  // 将遮罩层添加到 body
  document.body.appendChild(mask);
  
  // 点击遮罩层关闭弹窗
  mask.onclick = () => {
    showModal.value = false;
  };
}

watch(() => isInput.value, (val) => {
  if(!val) {
    showModal.value = false
    modify.value = null;
    addMask()
    if(!showModal.value){
      removeMask();
    }
  }
})

watch(() => showModal.value, (val) => {
  if (!val && isInput.value) {
    addMask();
  } else {
    removeMask();
  }
})


const currentApp = computed(() => {
  const idx = appList.value.findIndex(item => item.appId === activeName.value)
  if (idx === -1) return {}
  return appList.value[idx]
})

const currentIdx = computed(() => {
  const idx = appList.value.findIndex(item => item.appId === activeName.value)
  if (idx === -1) return false
  return idx
})

defineExpose({
  open
})
</script>

<style lang="scss" scoped>
:deep(.drawer-body) {
  padding: 0px;
}

.preview-main-collapse {
  flex: 1;
  border-left: 1px solid #ededed;
}

.preview-content {
  height: 100%;
  ::v-deep &-tabs {
    flex: 1;
    overflow: auto;

    .el-tabs__header {
      margin-bottom: 0;
      border-bottom: none;
    }

    .el-tabs__nav {
      border-left: none;
    }

    .el-tabs__item {
      color: #606266;
      font-weight: 400;
      background-color: rgba(0, 0, 0, .03);
      box-shadow: none !important;

      &:focus {
        box-shadow: none;
      }
    }

    .is-active {
      background-color: #fff;
      color: #4550DC;
    }
  }

  &-header {
    height: 40px;
    border-bottom: 1px solid #ededed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    margin-bottom: 5px;

    i {
      margin-right: 4px;
    }

    .close-btn::before {
      content: '';
      display: inline-block;
      height: 28px;
      width: 1px;
      background-color: #ededed;
      margin-right: 14px;
    }
  }

  iframe {
    height: calc(100% - 55px);
  }

  .iframe-mask {
    height: 100%;
  }
}
</style>